import emailRequired from './emailRequired';
import phoneRequired from './phoneRequired';

/**
 * Given form values and selected lists, validates the form and returns error messages.
 * @param {object} formValues - Form values for email, first, last, and phone.
 * @param {array} selectedLists - An array of selected list IDs and types.
 * @returns {array} An array of error messages, if the form is invalid. An empty array if valid.
 */
const getFormErrors = (formValues, selectedLists) => {
  // Keep track of errors.
  const errors = [];

  // The first name field is always required.
  if ('' === formValues.first_name) {
    errors.push('First name required.');
  }

  // The last name field is always required.
  if ('' === formValues.last_name) {
    errors.push('Last name required.');
  }

  // A valid ZIP code is always required.
  if ('' === formValues.zip_code) {
    errors.push('ZIP code required.');
  } else if (! /^\d{5}(-\d{4})?$/.test(formValues.zip_code)) {
    errors.push('Please enter a valid ZIP code.');
  }

  // Email is required if the user has opted in to an email list.
  if (emailRequired(selectedLists)) {
    if ('' === formValues.email) {
      errors.push('Please enter your email address.');
    } else if (! /^[a-zA-Z0-9.!#$%&’*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/.test(formValues.email)) { // eslint-disable-line max-len
      errors.push('Please enter a valid email.');
    }
  }

  // Phone is required if the user has opted in to an SMS list.
  if ('' === formValues.phone && phoneRequired(selectedLists)) {
    errors.push('Please enter your phone number.');
  }

  // Consent is always required.
  if (false === formValues.consent) {
    errors.push('You must agree to subscription terms.');
  }

  return errors;
};

export default getFormErrors;
